/**
 * Divider with Heading.
 *
 * @package
 */

/**
 * Internal dependencies.
 */
 import Edit from './edit';
 /**
  * WordPress Dependencies.
  */ 
 import { registerBlockType } from '@wordpress/blocks';
 import { InnerBlocks, useBlockProps } from '@wordpress/block-editor';
 import { columns } from '@wordpress/icons'; 
 import { __ } from '@wordpress/i18n';
 /**
  * Register block type.
  */
 registerBlockType( 'ssvreutlingen-blocks/text-middle', {

	apiVersion: 2,
	 /**
	  * Block title.
	  *
	  * @type {string}
	  */ 
	 title: __( 'SSV Text mittig', 'ssvreutlingen' ),
 
	 /**
	  * Block icon.
	  *
	  * @type {string}
	  */
	 icon: columns,

	
	 /**
	  * Block description.
	  *
	  * @type {string}
	  */
	 description: __( 'Text Element mit mittiger Ausrichtung.', 'ssvreutlingen' ),
 
	 /**
	  * Block category.
	  *
	  * @type {string}
	  */
	 category: 'ssvreutlingen',

	 edit: Edit,

 
	 /**
	  * Save function.
	  *
	  * @param {Object} props                    Props
	  *
	  * @param          props.attributes
	  * @param          props.attributes.content
	  * @return {Object} Content.
	  */
	 save() {
		 const blockProps = useBlockProps.save();
		 return (
			<div className='page__content -middletext'>
				<div className='page__content-text text'>
					<InnerBlocks.Content />
				</div>
			</div>
		);
	 },
 } );
 